import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { collection, addDoc, getDocs, deleteDoc, doc, query, orderBy } from 'firebase/firestore';
import { socialConfig } from './socialConfig';

const SocialManager = () => {
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const [category, setCategory] = useState('ফেসবুক পেজ');
  const [socials, setSocials] = useState([]);

  const fetchSocials = async () => {
    try {
      const q = query(
  collection(db, "socialLinks"),
  orderBy("name")
);
      const querySnapshot = await getDocs(q);
      setSocials(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (error) {
      console.error("লিস্ট আনতে সমস্যা হয়েছে:", error);
    }
  };

  useEffect(() => {
    fetchSocials();
  }, []);
const handleAdd = async (e) => {
  e.preventDefault();

  try {
    await addDoc(collection(db, "socialLinks"), {
      name,
      url,
      category
    });

    await fetchSocials();

    alert("সোশ্যাল লিংক সফলভাবে যুক্ত হয়েছে!");

    setName("");
    setUrl("");

  } catch (error) {
    console.error(error);
    alert("সংযুক্ত করতে সমস্যা হয়েছে!");
  }
};

  const handleDelete = async (id) => {
    if (window.confirm("আপনি কি এটি ডিলিট করতে চান?")) {
      await deleteDoc(doc(db, "socialLinks", id));
      fetchSocials();
    }
  };

  return (
    <div style={{ padding: '10px' }}>
      <h3>সোশ্যাল মিডিয়া লিংক ম্যানেজমেন্ট</h3>
      <form onSubmit={handleAdd} style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
        <input type="text" placeholder="নাম" value={name} onChange={(e) => setName(e.target.value)} required style={{ padding: '8px' }} />
        <input type="text" placeholder="ইউআরএল (URL)" value={url} onChange={(e) => setUrl(e.target.value)} required style={{ padding: '8px' }} />
        <select value={category} onChange={(e) => setCategory(e.target.value)} style={{ padding: '8px' }}>
          <option value="ফেসবুক পেজ">ফেসবুক পেজ</option>
          <option value="ইউটিউব চ্যানেল">ইউটিউব চ্যানেল</option>
          <option value="টিকটক">টিকটক</option>
          <option value="টুইটার">টুইটার</option>
          <option value="ইনস্টাগ্রাম">ইনস্টাগ্রাম</option>
		   <option value="হোয়াটসঅ্যাপ">হোয়াটসঅ্যাপ</option>
          <option value="অন্যান্য">অন্যান্য ইনফো</option>
        </select>
        <button 
          type="submit" 
          style={{ 
            padding: '8px 15px', 
            background: '#666', 
            fontSize: '18px',
            color: '#fff', 
            border: 'none', 
            cursor: 'pointer',
            borderRadius: '4px',
            transition: 'background-color 0.1s ease'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = 'royalBlue'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#666'}
        >
          যুক্ত করুন
        </button>
      </form>

      <ul style={{ listStyle: 'none', padding: 0 }}>
        {socials.map(s => {
          // ক্যাটাগরি অনুযায়ী সঠিক কনফিগারেশন বের করা (ট্রিম করে অতিরিক্ত স্পেস রিমুভ করা হলো)
          const cleanCategory = s.category ? s.category.trim() : '';
          const social = socialConfig[cleanCategory] || socialConfig['অন্যান্য'];
          const IconComponent = social.icon;

          return (
            <li key={s.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #ddd', padding: '8px 0' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {/* ডায়নামিক আইকন এবং ব্র্যান্ড কালার */}
                <span style={{ color: social.color, fontSize: '20px' }}>
                  <IconComponent />
                </span>
                <span><b>[{s.category}]</b> {s.name} - <a href={s.url} target="_blank" rel="noreferrer">{s.url}</a></span>
              </div>
              <button 
                onClick={() => handleDelete(s.id)} 
                style={{ 
                  background: '#666', 
                  color: '#fff', 
                  border: 'none', 
                  padding: '4px 8px', 
                  cursor: 'pointer',
                  borderRadius: '4px',
                  transition: 'background-color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#8b0000'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#666'}
              >
                ডিলিট
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SocialManager;